import { baseFetch } from "../api/baseFetch";
import { getUrlWithSearchParams } from "../common/helpres/link";
import { membersLink } from "../credentials/consts/links";
export var ApiGetUsesRemaining;
(function (ApiGetUsesRemaining) {
    ApiGetUsesRemaining.get = async (moduleId) => {
        return (await baseFetch({
            method: "GET",
            url: getUrlWithSearchParams(`${membersLink}/api/v1/customers/uses/get-uses-remaining`, {
                moduleId,
            }),
            withCredentials: true,
        })).results;
    };
})(ApiGetUsesRemaining || (ApiGetUsesRemaining = {}));
